import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ADMIN_API_URLS} from '../config/api.urls';
import { Observable } from 'rxjs';
import { IPagination } from '../_models/pagination';
import { Payment } from '../_models/payment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private httpClient: HttpClient) { }

  public loadPayments(page?: string): Observable<{ data: IPagination }> {
    if (page == null) {
      page = '1';
    }
    return this.httpClient.get<{ data: IPagination }>(ADMIN_API_URLS.PAYMENTS_PATH + `?page=${page}`);
  }

  public loadPayment(id: string): Observable<{ data: Payment }> {
    return this.httpClient.get<{ data: Payment }>(`${ADMIN_API_URLS.PAYMENTS_PATH}/${id}`);
  }

  public changePaymentStatus(id: string, status: string): Observable<any> {
    return this.httpClient.put(`${ADMIN_API_URLS.PAYMENTS_PATH}/${id}/changeStatus`, {}, { params: { status } });
  }

  searchPayment(searchTerm: string, paymentMethod: string, status: string, page: string): Observable<any> {
    return this.httpClient.get(`${ADMIN_API_URLS.PAYMENTS_PATH}/search`, {params: {searchTerm: searchTerm, paymentMethod: paymentMethod, status:status, page: page}});
  }
}
